import { render, staticRenderFns } from "./PersonView.vue?vue&type=template&id=9ae40586&scoped=true&"
import script from "./PersonView.vue?vue&type=script&lang=js&"
export * from "./PersonView.vue?vue&type=script&lang=js&"
import style0 from "./PersonView.vue?vue&type=style&index=0&id=9ae40586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae40586",
  null
  
)

export default component.exports